import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 my-4" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "font-semibold" }

import { Profile } from "@/models/Profile";



export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerGdprAgencyRecipient',
  props: {
  company: {
    type: Profile,
    required: true,
  },
  recipientCompany: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "text-lg font-bold" }, "Mottagare – utlämning till kundföretag", -1)),
    _createElementVNode("p", _hoisted_2, [
      _cache[0] || (_cache[0] = _createTextVNode(" Denna annons hanteras ", -1)),
      (props?.company?.DisplayName?.data)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("av " + _toDisplayString(props?.company?.DisplayName?.data), 1)
          ], 64))
        : _createCommentVNode("", true),
      _cache[1] || (_cache[1] = _createTextVNode(" på uppdrag av ett kundföretag. Genom att godkänna samtycker Du till att de personuppgifter Du lämnar i Din ansökan kan komma att lämnas ut till följande kundföretag, som självständigt personuppgiftsansvarig, för beslut i rekryteringsärendet: ", -1))
    ]),
    _createElementVNode("p", _hoisted_3, _toDisplayString(props.recipientCompany), 1)
  ]))
}
}

})